export default {
  methods: {
    toggleBodyOverflow() {
      document.body.classList.toggle('overflow-hidden');
    },
  },
};
